import useFilterMetadata from './useFilterMetadata';
import { useFilterInterdependencyBoundary } from '../components/contextProviders/FilterInterdependencyBoundary';

const _p = { useFilterInterdependencyBoundary, useFilterMetadata };
export default function useRegisterWithFilterInterdependencyBoundary(hNode) {
    const {
        namespace,
        foreignNamespace: tempForeignNamespace,
        relation,
        foreignRelation: tempForeignRelation
    } = hNode ?? {};
    // Some consumers of this abstract component use namespace/relation instead of
    // foreignNamespace/foreignRelation.
    const foreignNamespace = tempForeignNamespace || namespace;
    const foreignRelation = tempForeignRelation || relation;

    const filterMetadata = _p.useFilterMetadata(hNode);
    const FilterInterdependencyBoundary = _p.useFilterInterdependencyBoundary();

    // Register synchronously during render (not in a useEffect) so the entry exists
    // in listeningFilters before any useLayoutEffect fires.  The previous useEffect
    // caused a race: the cascade (triggered in useLayoutEffect) fired before Building's
    // useEffect registration ran, so dependentViews was empty and Building was never cleared.
    // addFilterMetadata deduplicates by filterId + view ns/rel, so calling it every render
    // is safe — subsequent calls with no viewCriteria are no-ops once the entry exists.
    FilterInterdependencyBoundary?.addFilterMetadata(
        { namespace: foreignNamespace, relation: foreignRelation },
        filterMetadata
    );
}
export const _private = _p;
